import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { DateRange } from '@/components/molecules/DateRangePicker/DateRangePicker';
import {
    isLiceReportRangeWithinLimit,
    MAX_LICE_REPORT_RANGE_DAYS,
} from '@/routes/Client/LiceReport/helpers/liceReportRange';
import { showLiceReportRangeExceededToast } from '@/routes/Client/LiceReport/helpers/rangeExceededToast';

export function useLiceReportRangeChange(
    setRange: (range: { from: string; to: string }) => void
): (dateRange: DateRange) => void {
    const { t } = useTranslation('liceReport');

    return useCallback(
        (dateRange: DateRange) => {
            if (!dateRange.dateFrom || !dateRange.dateTo) {
                return;
            }
            if (!isLiceReportRangeWithinLimit(dateRange.dateFrom, dateRange.dateTo)) {
                showLiceReportRangeExceededToast(
                    t('common.rangeExceedsMaxDays', { maxDays: MAX_LICE_REPORT_RANGE_DAYS })
                );
                return;
            }
            setRange({ from: dateRange.dateFrom, to: dateRange.dateTo });
        },
        [setRange, t]
    );
}
